var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.empty)?_c('commodity-list',{attrs:{"code":_vm.data}}):_c('empty-data',{attrs:{"is-show":{ empty: true, stroll: true }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }